import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const PROGRESS_BAR_DOTS = '[data-free-shipping-progress-bar-dots]'
const MESSAGE_NODE_SELECTOR = '[data-free-shipping-bar-message]'

export class FreeShippingBar extends BaseComponent {
  connectedCallback() {
    const {
      cartTotal,
      currencyFormat,
      threshold,
      progressMessage,
      achievedMessage,
    } = this.dataset

    const thresholdRated = +threshold * +Shopify.currency.rate
    const diffNumber = +(thresholdRated - +cartTotal).toFixed(2)
    const diffPercent = (+cartTotal / thresholdRated) * 100

    if (diffNumber > 0) {
      const m = currencyFormat.replace(/{{.+?}}/g, `${diffNumber}`)
      this.setText(progressMessage.replace('[value]', m))
      this.setProgress(diffPercent)
    } else {
      this.setText(achievedMessage)
      this.setProgress(100)
    }
  }

  setProgress = (value: number): void => {
    const dots = $el(PROGRESS_BAR_DOTS, this)

    if (dots) {
      dots.setAttribute('style', `--gsc-freeshipping-bar-percent: ${value}%`)
    }
  }

  setText = (text: string): void => {
    const messageNode = $el(MESSAGE_NODE_SELECTOR, this)
    messageNode?.replaceChildren(text)
  }
}
